import React from "react";
import { ArchiveMorphologyStore } from '../ArchiveMorphologyStore';
import MobilePopup from '../../shared/MobilePopup/MobilePopup';
import Cookies from 'js-cookie';
import { PuzzleNames } from '../../../../utils/types';
import { DOMAIN } from '../../shared/utils';

const MobileMorphologyInstructions = () => {
  const isOpen = ArchiveMorphologyStore.useState(s => s.instructionsAreOpen);
  const cryptic = ArchiveMorphologyStore.useState(s => s.cryptic);

  const onClose = () => {
    Cookies.set(`${PuzzleNames.Morphology}InstructionsDismissed`, 'true', {
      domain: DOMAIN,
      expires: 365,
    });
    ArchiveMorphologyStore.update(s => {
      s.instructionsAreOpen = false;
      s.isSoftPaused = false;
    });
  };

  return (
    <MobilePopup isOpen={isOpen} onClose={onClose} title="How to Play Morphology">
      <ul>
        <li>Fill in the word ladder with single-word solutions matching the clues.</li>
        <li>Each solution differs from the previous clue's solution by just a few letters. The difference is called the <span className="italicText">morph</span> and is given in the format <span className="morphText">(+X, -Y, ~Z)</span>.</li>
        <ul className="sublist">
          <li><span className="morphText">+X</span> means X characters were added.<br/> CHAT is <span className="morphText">+1</span> from CAT.</li>
          <li><span className="morphText">-Y</span> means Y characters were removed.<br/> RAIN is <span className="morphText">-2</span> from RACING.</li>
          <li><span className="morphText">~Z</span> means Z characters were changed.<br/> GUITAR is <span className="morphText">~2</span> from SUITOR.</li>
        </ul>
        <li>Morphology usually avoids obscure words, as well as proper names that aren't commonplace or inferrable by the morph.</li>
        {cryptic && <li className="crypticCallout"><b>This puzzle is a cryptic, which follows cryptic crossword clueing conventions. Learn more via <a target="_blank" href="https://www.youtube.com/watch?v=HrKiYFJxgic">this video</a>, <a target="_blank" href="https://www.newyorker.com/puzzles-and-games-dept/cryptic-crossword/reintroducing-the-new-yorkers-cryptic-crossword">this article</a>, or <a target="_blank" href="https://s.wsj.net/blogs/html/wsjcrypticguide.pdf">this concise PDF</a>.</b></li>}
      </ul>
    </MobilePopup>
  );
};

export default MobileMorphologyInstructions;